/**
 * Describing a structural editing context where a plain Enter keystroke should
 * defer to RoosterJS' native handling
 */ export const DefaultEnterSuppressors = [
    "LI",
    "BLOCKQUOTE",
    "PRE,CODE",
    "TD,TH"
];
/**
 * Returns true if the caret is currently inside a structural editing context where a
 * plain Enter should be handled by the editor (newline / continue / exit) rather than
 * trigger sending the message.
 */ export function isStructuralEnterContext(editor) {
    return DefaultEnterSuppressors.some((s)=>!!editor.getElementAtCursor(s));
}
